import React, {
  useEffect,
  useState,
  useRef,
  useCallback,
  useMemo,
} from "react";
import axios from "axios";

import { useParams, Link } from "react-router-dom";
import config from "../../../config/config";
import Loader from "../../../components/Loader/Loader";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";

import moment from "moment";
import ReportDate from "../../../components/Reports/ReportDate";
import Select from "react-select";

//--------Material React Table------//
import { MaterialReactTable } from "material-react-table";
import { Box, Button } from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";

const currentDate = new Date();
const monthNames = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
const month = monthNames[currentDate.getMonth()]; // add 1 to get month value from 1 to 12
const hours = currentDate.getUTCHours();
const minutes = currentDate.getUTCMinutes();

const SalesbyCustomerDetail = (props) => {
  const token = localStorage.getItem("Token");
  const [formValues, setFormValues] = useState([]);
  const [responseData, setResponseData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalSum, setTotalSum] = useState(0);
  const [selectedId, setSelectedId] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [startdate, setStartDate] = useState("");
  const [enddate, setEndDate] = useState("");
  const [selectedDate, setSelectedDate] = useState([]);
  const [selectReport, setSelectReport] = useState(1);

  //----------------Server-Side------------------//
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);

  //table state
  const [columnFilters, setColumnFilters] = useState([]);
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState([]);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 50,
  });

  console.log(selectReport, "selectReport");
  // console.log(JSON.parse((sorting)), "sorting")
  // console.log(columnFilters, "columnFilters")

  const ITEMS_PER_PAGE = 10;

  const [data, setData] = useState(
    []
    // inputValue: "",
    // width: 1,
    // height: 20,
    // fontSize: 15,
    // zeroFill: 10,
  );

  const handleDropdownChange = (event) => {
    console.log(event, "event");
    setSelectReport(event?.value);
  };

  const paramObject = useParams();
  const apicall = () => {
    return;
    axios
      .get(
        `${config.reportsBaseUrl}/reports/salesbycustomerdetail?startdate=${startdate}&enddate=${enddate}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        console.log("res======>", res);
        console.log(res.data.ResponseData, "res======>");
        if (res.data.ResponseCode === "SUCCESS") {
          setResponseData(res.data.ResponseData);
          setData(res.data.ResponseData);

          //   barcodeRefs.current = responseData;
        }
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };
  console.log("11", responseData);

  useEffect(() => {
    axios
      .get(`${config.reportsBaseUrl}/reports/reportperioddropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        console.log("setSelectedDate======>", res);
        setSelectedDate(res.data.ResponseData);
        // setLoading(false);
        return res;
      });
  }, []);

  // to calculate the total
  const calculateTotalSum = () => {
    const sum = responseData.reduce((total, data) => {
      const reportTotal = Number(data.Amountline);

      if (typeof reportTotal === "number" && !isNaN(reportTotal)) {
        return total + reportTotal;
      } else {
        return total;
      }
    }, 0);

    setTotalSum(sum);
  };

  useEffect(() => {
    calculateTotalSum();
  }, [responseData]);

  const callback = (payload, enddate2) => {
    console.log("startenddate =>", payload, enddate2);
    setStartDate(payload);
    setEndDate(enddate2);

    // console.log("enddate =>", enddate2);
  };
  const totalPages = Math.ceil(responseData.length / ITEMS_PER_PAGE);

  const columnDefs = [
    { field: "Customername", enableRowGroup: true },
    { field: "DATE", enableRowGroup: true },
    { field: "TransactionType", enableRowGroup: true },
    { field: "TransactionType", enableRowGroup: true },
    { field: "Transactionnumber", enableRowGroup: true },
    { field: "Name" },
    // { field: "Description" },
    { field: "Quantity", enableRowGroup: true },
    { field: "Rate", enableRowGroup: true },
    {
      field: "Amountline",
      width: 200,
      enableValue: true,

      suppressMenu: true,
      filter: "agNumberColumnFilter",
      aggFunc: "sum",
      valueGetter: function (params) {
        // Parse the string OpenBalance and return as an integer
        const amount = parseInt(params.data.Amountline, 10);
        return isNaN(amount) ? 0 : amount;
      },
    },
    { field: "Balance" },
  ];
  const defaultColDef = {
    sortable: true,
  };
  const autoGroupColumnDef = {
    comparator: (valueA, valueB, nodeA, nodeB, isDescending) => {
      var res = valueA == valueB ? 0 : valueA > valueB ? 1 : -1;
      return res;
    },
    field: "athlete",
    sort: "asc",
  };

  const onGridReady = useCallback((params) => {
    setLoading(true);
    axios
      .get(
        `${
          config.reportsBaseUrl
        }/reports/salesbycustomerdetail?startdate=${""}&enddate=${""}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        console.log("res======>", res);
        console.log(res.data.ResponseData);
        if (res.data.ResponseCode === "SUCCESS") {
          setResponseData(res.data.ResponseData);
          setData(res.data.ResponseData);
        }
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  }, []);

  // useEffect(() => {
  //   onGridReady();
  // }, [onGridReady]);

  const totalFooterRow = {
    Customername: "Total",
    Amountline: totalSum,
  };

  const augmentedData = [...responseData, totalFooterRow];

  const onBtExport = () => {
    const workbook = XLSX.utils.book_new();

    // Convert the data to a worksheet
    const worksheet = XLSX.utils.json_to_sheet(responseData);

    // Add the worksheet to the workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Save the workbook as an Excel file
    XLSX.writeFile(workbook, `SalesbyCustomerDetail_.xlsx`);
  };

  // const downloadPDF = () => {
  //   setLoading(true);
  //   var doc = new jsPDF("p", "pt", "a4");

  //   // Add the header
  //   let headerElement = document.querySelector("#header");
  //   let clonedHeader = headerElement.cloneNode(true);
  //   clonedHeader.style.fontSize = `10px`;
  //   clonedHeader.style.width = "560px";
  //   clonedHeader.style.margin = "1rem";

  //   let content = "";
  //   let startIndex = 1;
  //   let endIndex = 25;

  //   for (var i = 1; i <= Math.ceil(data.length / 25); i++) {
  //     if (i == 1) {
  //       clonedHeader.style.marginTop = "2rem";
  //     }
  //     if (i > 1) {
  //       clonedHeader.style.marginTop = "2.5rem";
  //     }
  //     // Printing header
  //     content += " " + clonedHeader.outerHTML;

  //     // Printing table body
  //     content +=
  //       '<table style="font-size: 8px; margin-left: 1rem; margin-top: 1rem; width: 560px; border: 1px solid #f5f5f5">';
  //     content +=
  //       "<thead><tr style='margin-bottom: 5px'>" +
  //       '<th style="padding: 7px;">No</th>' +
  //       '<th style="padding: 7px;">CustomerName</th>' +
  //       '<th style="padding: 6px;">Date</th>' +
  //       '<th style="padding: 7px; ">TransactionType</th>' +
  //       '<th style="padding: 7px; ">TransactionNo.</th>' +
  //       '<th style="padding: 7px;">Name</th>' +
  //       '<th style="padding: 7px; ">Quantity</th>' +
  //       '<th style="padding: 7px; ">Rate</th>' +
  //       '<th style="padding: 7px; ">AmountLine</th>' +
  //       '<th style="padding: 7px; ">Balance</th>' +
  //       "</tr></thead>";
  //     content += "<tbody>";

  //     // Loop for printing items based on endIndex
  //     for (let index = startIndex; index <= endIndex; index++) {
  //       if (index <= data.length) {
  //         content +=
  //           "<tr>" +
  //           '<td style="font-size: 7px; padding: 7px;">' +
  //           index +
  //           "</td>" +
  //           '<td style="font-size: 7px; padding: 7px;">' +
  //           data[index - 1].Customername +
  //           "</td>" +
  //           '<td style="font-size: 6px; padding: 7px;">' +
  //           moment(data[index - 1].DATE).format("YYYY/MM/DD") +
  //           "</td>" +
  //           '<td style="font-size: 7px; padding: 7px; ">' +
  //           data[index - 1].TransactionType +
  //           "</td>" +
  //           '<td style="font-size: 7px; padding: 7px;">' +
  //           data[index - 1].Transactionnumber +
  //           "</td>" +
  //           '<td style="font-size: 6px; ">' +
  //           data[index - 1].Name +
  //           "</td>" +
  //           '<td style="font-size: 7px; padding: 7px; ">' +
  //           data[index - 1].Quantity +
  //           "</td>" +
  //           '<td style="font-size: 7px; padding: 7px; text-align: right;">' +
  //           data[index - 1].Rate +
  //           "</td>" +
  //           '<td style="font-size: 7px; padding: 7px; ">' +
  //           Number(data[index - 1].Amountline).toFixed(2) +
  //           "</td>" +
  //           '<td style="font-size: 7px; padding: 7px; ">' +
  //           Number(data[index - 1].Balance).toFixed(2) +
  //           "</td>" +
  //           "</tr>";
  //       }

  //       if (index % 25 == 0) {
  //         startIndex = startIndex + 25;
  //         endIndex = endIndex + 25;
  //         break;
  //       }
  //     }

  //     content += "</tbody>";
  //     content += "</table>";

  //     content +=
  //       '<div style="text-align: center; width: 560px">' +
  //       '<p style= "text-align: center; margin-top: 0rem; font-size: 9px; font-weight: bold;">' +
  //       i +
  //       "</p>" +
  //       "</div>";
  //   }

  //   // Printing page
  //   doc.html(content, {
  //     callback: function (pdf) {
  //       pdf.save("Sales-Customer-Details.pdf");
  //       setLoading(false);
  //     },
  //   });
  // };

  const downloadPDF = (rows, field) => {
    let newData = [];
    if (field === "selectedrow") {
      newData = rows.map((row) => row.original);
    } else if (field === "alldata") {
      newData = responseData;
    }

    console.log(newData, "newData");
    setLoading(true);
    var doc = new jsPDF("p", "pt", "a4");

    // Add the header
    let headerElement = document.querySelector("#header");
    let clonedHeader = headerElement.cloneNode(true);
    clonedHeader.style.fontSize = `10px`;
    clonedHeader.style.width = "560px";
    clonedHeader.style.margin = "1rem";

    let content = "";
    let startIndex = 1;
    let endIndex = 25;

    for (var i = 1; i <= Math.ceil(newData.length / 25); i++) {
      if (i == 1) {
        clonedHeader.style.marginTop = "2rem";
      }
      if (i > 1) {
        clonedHeader.style.marginTop = "2.5rem";
      }
      // Printing header
      content += " " + clonedHeader.outerHTML;

      // Printing table body
      content +=
        '<table style="font-size: 8px; margin-left: 1rem; margin-top: 2rem; width: 560px; border: 1px solid #f5f5f5">';
      content +=
        "<thead><tr style='margin-bottom: 5px'>" +
        '<th style="padding: 7px;">No</th>' +
        '<th style="padding: 7px;">CustomerName</th>' +
        '<th style="padding: 7px;">Date</th>' +
        '<th style="padding: 7px; ">TransactionType</th>' +
        '<th style="padding: 7px; ">Transaction No.</th>' +
        '<th style="padding: 7px;">Name</th>' +
        '<th style="padding: 7px; ">Quantity</th>' +
        '<th style="padding: 7px; ">Rate</th>' +
        '<th style="padding: 7px; ">Amount</th>' +
        '<th style="padding: 7px; ">Balance</th>' +
        "</tr></thead>";
      content += "<tbody>";

      // Loop for printing items based on endIndex
      for (let index = startIndex; index <= endIndex; index++) {
        if (index <= newData.length) {
          content +=
            "<tr>" +
            '<td style="font-size: 7px; padding: 7px;">' +
            index +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px;">' +
            newData[index - 1].Customername +
            "</td>" +
            '<td style="font-size: 6px; padding: 7px;">' +
            moment(newData[index - 1].DATE).format("DD-MM-YYYY") +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px; ">' +
            newData[index - 1].TransactionType +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px;">' +
            newData[index - 1].Transactionnumber +
            "</td>" +
            '<td style="font-size: 6px; ">' +
            newData[index - 1].Name +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px; ">' +
            newData[index - 1].Quantity +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px; text-align: right;">' +
            newData[index - 1].Rate +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px; ">' +
            Number(newData[index - 1].Amountline).toFixed(2) +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px; ">' +
            Number(newData[index - 1].Balance).toFixed(2) +
            "</td>" +
            "</tr>";
        }

        if (index % 25 == 0) {
          startIndex = startIndex + 25;
          endIndex = endIndex + 25;
          break;
        }
      }

      content += "</tbody>";
      content += "</table>";

      content +=
        '<div style="text-align: center; width: 560px">' +
        '<p style= "text-align: center; margin-top: 1rem; font-size: 9px; font-weight: bold;">' +
        i +
        "</p>" +
        "</div>";
    }

    // Printing page
    doc.html(content, {
      callback: function (pdf) {
        pdf.save("Sales-Customer-Details.pdf");
        setLoading(false);
      },
    });
  };

  // const onBtPrint = () => {
  //   setLoading(true);
  //   var doc = new jsPDF("p", "pt", "a4");

  //   // Add the header
  //   let headerElement = document.querySelector("#header");
  //   let clonedHeader = headerElement.cloneNode(true);
  //   clonedHeader.style.fontSize = `10px`;
  //   clonedHeader.style.width = "560px";
  //   clonedHeader.style.margin = "1rem";

  //   let content = "";
  //   let startIndex = 1;
  //   let endIndex = 25;

  //   for (var i = 1; i <= Math.ceil(data.length / 25); i++) {
  //     if (i == 1) {
  //       clonedHeader.style.marginTop = "2rem";
  //     }
  //     if (i > 1) {
  //       clonedHeader.style.marginTop = "2.5rem";
  //     }
  //     // Printing header
  //     content += " " + clonedHeader.outerHTML;

  //     // Printing table body
  //     content +=
  //       '<table style="font-size: 8px; margin-left: 1rem; margin-top: 2rem; width: 560px; border: 1px solid #f5f5f5">';
  //     content +=
  //       "<thead><tr style='margin-bottom: 5px'>" +
  //       '<th style="padding: 7px;">No</th>' +
  //       '<th style="padding: 7px;">CustomerName</th>' +
  //       '<th style="padding: 7px;">Date</th>' +
  //       '<th style="padding: 7px; ">TransactionType</th>' +
  //       '<th style="padding: 7px; ">TransactionNumber</th>' +
  //       '<th style="padding: 7px;">Name</th>' +
  //       '<th style="padding: 7px; ">Quantity</th>' +
  //       '<th style="padding: 7px; ">Rate</th>' +
  //       '<th style="padding: 7px; ">AmountLine</th>' +
  //       '<th style="padding: 7px; ">Balance</th>' +
  //       "</tr></thead>";
  //     content += "<tbody>";

  //     // Loop for printing items based on endIndex
  //     for (let index = startIndex; index <= endIndex; index++) {
  //       if (index <= data.length) {
  //         content +=
  //           "<tr>" +
  //           '<td style="font-size: 7px; padding: 7px;">' +
  //           index +
  //           "</td>" +
  //           '<td style="font-size: 7px; padding: 7px;">' +
  //           data[index - 1].Customername +
  //           "</td>" +
  //           '<td style="font-size: 7px; padding: 7px;">' +
  //           moment(data[index - 1].DATE).format('DD-MM-YYYY') +
  //           "</td>" +
  //           '<td style="font-size: 7px; padding: 7px; ">' +
  //           data[index - 1].TransactionType +
  //           "</td>" +
  //           '<td style="font-size: 7px; padding: 7px;">' +
  //           data[index - 1].Transactionnumber +
  //           "</td>" +
  //           '<td style="font-size: 6px; ">' +
  //           data[index - 1].Name +
  //           "</td>" +
  //           '<td style="font-size: 7px; padding: 7px; ">' +
  //           data[index - 1].Quantity +
  //           "</td>" +
  //           '<td style="font-size: 7px; padding: 7px; text-align: right;">' +
  //           data[index - 1].Rate +
  //           "</td>" +
  //           '<td style="font-size: 7px; padding: 7px; ">' +
  //           Number(data[index - 1].Amountline).toFixed(2) +
  //           "</td>" +
  //           '<td style="font-size: 7px; padding: 7px; ">' +
  //           Number(data[index - 1].Balance).toFixed(2) +
  //           "</td>" +
  //           "</tr>";
  //       }

  //       if (index % 25 == 0) {
  //         startIndex = startIndex + 25;
  //         endIndex = endIndex + 25;
  //         break;
  //       }
  //     }

  //     content += "</tbody>";
  //     content += "</table>";

  //     content +=
  //       '<div style="text-align: center; width: 560px">' +
  //       '<p style= "text-align: center; margin-top: 1rem; font-size: 9px; font-weight: bold;">' +
  //       i +
  //       "</p>" +
  //       "</div>";
  //   }

  //   // Printing page
  //   doc.html(content, {
  //     callback: function (pdf) {
  //       pdf.output("dataurlnewwindow");
  //       setLoading(false);
  //     },
  //   });
  // };

  let reportdropdown = [];
  const data2 = selectedDate.map(
    (u, i) => (reportdropdown[i] = { label: u.Name, value: u.ID })
  );

  //---------------------Material React Table------------------//
  const columns = useMemo(() => [
    {
      header: "Customer Name",
      accessorKey: "Customername",
      // enableGrouping: false, //do not let this column be grouped
    },
    {
      header: "DATE",
      accessorKey: "DATE",
      Cell: ({ row }) => moment(row.original.DATE).format("DD-MM-YYYY"),
    },
    {
      header: "Transaction Type",
      accessorKey: "TransactionType",
    },
    {
      header: "Transaction Number",
      accessorKey: "Transactionnumber",
    },
    {
      header: "Name",
      accessorKey: "Name",
    },
    {
      header: "Quantity",
      accessorKey: "Quantity",
    },
    {
      header: "Rate",
      accessorKey: "Rate",
    },
    {
      header: "Amount",
      accessorKey: "Amountline",
    },
    {
      header: "Balance",
      accessorKey: "Balance",
    },
  ]);

  useEffect(() => {
    // const fetchData = async () => {

    const columnIndex = columns.findIndex(
      (column) => column.accessorKey === sorting[0]?.id
    );
    console.log(
      JSON.stringify(columnFilters) + " columnFilters | ",
      globalFilter + " globalFilter | ",
      pagination.pageIndex + " pagination.pageIndex | ",
      pagination.pageSize + " pagination.pageSize | ",
      columnIndex,
      sorting[0]?.id,
      sorting[0]?.desc === undefined
        ? "desc"
        : (sorting[0]?.desc === true ? "desc" : "asc") + " sorting | ",
      startdate + " startdate | ",
      enddate + " enddate",
      "api Call payload"
    );

    const FilterColumnText = {};
    FilterColumnText.filtercolumntext = columnFilters;

    let FilterColumnSearchText = JSON.stringify(FilterColumnText);

    axios
      .get(
        `${
          config.reportsBaseUrl
        }/reports/salesbycustomerdetail?filtercolumnsearchtext=${FilterColumnSearchText}&currentorder=${
          sorting[0]?.desc === undefined
            ? "desc"
            : sorting[0]?.desc === true
            ? "desc"
            : "asc"
        }&ordercolumn=${columnIndex === -1 ? 1 : columnIndex}&pagesize=${
          pagination.pageSize
        }&pagenumber=${pagination.pageIndex + 1}&filtertext=${
          globalFilter === undefined ? "" : globalFilter
        }&startdate=${startdate}&enddate=${enddate}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        console.log("res======>", res);
        console.log(res.data.ResponseData, "res======>");
        if (res.data.ResponseCode === "SUCCESS") {
          setResponseData(res.data.ResponseData);
          setData(res.data.ResponseData);
          setRowCount(res.data.ResponseData[0].TotalRecord);
          //   barcodeRefs.current = responseData;
        }
        setLoading(false);
      })
      .catch((err) => {
        setIsError(true);
        console.log(err);
        setLoading(false);
        return;
      });

    setIsError(false);
    setIsLoading(false);
    setIsRefetching(false);
    // }
    // fetchData();
  }, [
    columnFilters,
    globalFilter,
    pagination.pageIndex,
    pagination.pageSize,
    sorting,
    startdate,
    enddate,
  ]);

  const handleExportRows = (rows) => {
    console.log(
      rows.map((row) => row.original),
      "selected row"
    );
    // csvExporter.generateCsv(rows.map((row) => row.original));

    const workbook = XLSX.utils.book_new();
    // Convert the data to a worksheet
    const worksheet = XLSX.utils.json_to_sheet(rows.map((row) => row.original));
    // Add the worksheet to the workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Save the workbook as an Excel file
    XLSX.writeFile(workbook, `SalesbyCustomerDetail_.xlsx`);
  };

  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row" style={{ marginTop: "5px" }}>
              <h3 className="page-title">Sales By Customer Detail</h3>
              <ul className="breadcrumb">
                <li className="breadcrumb-item" style={{ marginLeft: "12px" }}>
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/report">Report</Link>
                </li>
                <li className="breadcrumb-item active">
                  Sales By Customer Detail
                </li>
              </ul>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-3 ">
              <div className="form-group row">
                <label className="col-form-label col-md-5 form-label">
                  Report period
                </label>
                <div className="col-md-7" style={{ zIndex: "998" }}>
                  <Select
                    options={reportdropdown}
                    value={reportdropdown.find(
                      (el) => el?.value === selectReport
                    )}
                    // defaultValue={selectReport}
                    // backspaceRemovesValue={false}
                    // controlShouldRenderValue={true}
                    hideSelectedOptions={true}
                    isClearable={true}
                    name="Reportperiod"
                    id="Reportperiod"
                    //  value={selectedDate}
                    onChange={(event) => {
                      handleDropdownChange(event);
                    }}
                    className="custom-search-select"
                  ></Select>
                </div>
              </div>
            </div>
            <div className="col-sm-6">
              <div className="form-group row">
                <ReportDate
                  callback={callback}
                  selectReport={selectReport}
                  showhidecomponent={
                    selectReport == 2 ||
                    selectReport == 3 ||
                    selectReport == 4 ||
                    selectReport == 5 ||
                    selectReport == 6 ||
                    selectReport == 7 ||
                    selectReport == 8 ||
                    selectReport == 9 ||
                    selectReport == 10 ||
                    selectReport == 11 ||
                    selectReport == 12 ||
                    selectReport == 13 ||
                    selectReport == 14 ||
                    selectReport == 15 ||
                    selectReport == 16 ||
                    selectReport == 17 ||
                    selectReport == 18 ||
                    selectReport == 19 ||
                    selectReport == 20 ||
                    selectReport == 21 ||
                    selectReport == 22 ||
                    selectReport == 23 ||
                    selectReport == 24 ||
                    selectReport == 25 ||
                    selectReport == 26 ||
                    selectReport == 27 ||
                    selectReport == 28 ||
                    selectReport == 29 ||
                    selectReport == 30 ||
                    selectReport == 31
                      ? true
                      : false
                  }
                />
              </div>
            </div>

            <div className="col-sm-3">
              <button
                type="submit"
                className="btn btn-sm btn-primary pull-right "
                style={{ marginLeft: "auto" }}
                onClick={apicall}
              >
                Generate Report
              </button>
            </div>
          </div>
          {/* <div style={{ display: "flex" }}>
            <button
              type="submit"
              className="btn btn-primary pull-right mb-3 w-25 mt-0"
              style={{ marginLeft: "auto" }}
              onClick={apicall}
            >
              Generate Report
            </button>
          </div> */}

          {/* Receipt */}

          <div className="card mt-0" id="print">
            <div className="card-body">
              <div className="container">
                <div className="col-md-12 text-center" id="header">
                  <h3>SonarPos</h3>
                  <h6 className="fw-bold">Sales By Customer Detail</h6>
                  <div className="row mb-0">
                    {/* <h6> Date: {new Date().toLocaleDateString()}</h6> */}
                    <h6>
                      Date:{" "}
                      {startdate === "" && enddate === ""
                        ? "All Data"
                        : startdate + " - " + enddate}
                    </h6>
                  </div>
                </div>
              </div>
              <hr />

              {/* <div className="button">
                <button
                  onClick={onBtExport}
                  className="btn btn-sm btn-outline-dark  m-1"
                  // style={{ marginBottom: '5px',marginLeft: "5px", fontWeight: 'bold' }}
                >
                  <i class="fas fa-file-excel mr-2"></i>
                  Export to Excel
                </button>
                <button
                  onClick={downloadPDF}
                  className="btn btn-sm btn-outline-dark  m-1"
                  // style={{ marginBottom: '5px',marginLeft: "5px", fontWeight: 'bold' }}
                >
                  <i class="fas fa-file-export mr-2"></i>
                  Export to Pdf
                </button>
                <button
                  className="btn btn-sm btn-outline-dark  m-1"
                  onClick={onBtPrint}
                >
                  {" "}
                  <i class="fas fa-print mr-2"></i>Print
                </button>
              </div> */}

              <div>
                {/* <div className="table-responsive"> */}
                {/* <div
                  className="ag-theme-alpine"
                  // style={{ height: "100vh", width: "100%" }}
                > */}
                <MaterialReactTable
                  columns={columns}
                  data={responseData}
                  // positionPagination='top'
                  enableColumnResizing
                  enableGrouping
                  enableStickyHeader
                  enableStickyFooter
                  enableRowSelection
                  enableColumnOrdering
                  // rowVirtualizerProps={{
                  //   overscan: 10, //adjust the number or rows that are rendered above and below the visible area of the table
                  //   estimateSize: () => 100, //if your rows are taller than normal, try tweaking this value to make scrollbar size more accurate
                  // }}
                  muiTableContainerProps={{ sx: { maxHeight: "fit-content" } }}
                  initialState={{
                    density: "compact",
                    expanded: true, //expand all groups by default
                    // grouping: [""], //an array of columns to group by by default (can be multiple)
                    pagination: { pageIndex: 0, pageSize: 50 },
                    // sorting: { id: "Name", desc: false }, //sort by state by default
                  }}
                  // muiToolbarAlertBannerChipProps={{ color: "primary" }}
                  // muiTableContainerProps={{ sx: { maxHeight: 700 } }}

                  muiTablePaginationProps={{
                    rowsPerPageOptions: [50, 100, 300, 500],
                  }}
                  // manualFiltering  // for termp comment filteron column
                  manualPagination
                  manualSorting
                  muiToolbarAlertBannerProps={
                    isError
                      ? {
                          color: "error",
                          children: "Error loading data",
                        }
                      : undefined
                  }
                  // onColumnFiltersChange={setColumnFilters} // for termp comment filteron column
                  onGlobalFilterChange={setGlobalFilter}
                  onPaginationChange={setPagination}
                  onSortingChange={setSorting}
                  rowCount={rowCount}
                  // enableColumnVirtualization={false}
                  // enableColumnVirtualization
                  state={{
                    // columnFilters, // for termp comment filteron column
                    globalFilter,
                    isLoading,
                    pagination,
                    showAlertBanner: isError,
                    showProgressBars: isRefetching,
                    sorting,
                  }}
                  renderTopToolbarCustomActions={({ table }) => (
                    <Box
                      sx={{
                        display: "flex",
                        gap: "1rem",
                        p: "0.5rem",
                        flexWrap: "wrap",
                      }}
                    >
                      <Button
                        size="small"
                        color="primary"
                        //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
                        onClick={onBtExport}
                        startIcon={<FileDownloadIcon />}
                        variant="contained"
                      >
                        Export All In Excel
                      </Button>
                      <Button
                        size="small"
                        disabled={
                          !table.getIsSomeRowsSelected() &&
                          !table.getIsAllRowsSelected()
                        }
                        //only export selected rows
                        onClick={() =>
                          handleExportRows(table.getSelectedRowModel().rows)
                        }
                        startIcon={<FileDownloadIcon />}
                        variant="contained"
                      >
                        Export Selected Rows in Excel
                      </Button>
                      <Button
                        size="small"
                        color="primary"
                        //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
                        onClick={() => downloadPDF("", "alldata")}
                        startIcon={<FileDownloadIcon />}
                        variant="contained"
                      >
                        Export All In Pdf
                      </Button>
                      <Button
                        size="small"
                        disabled={
                          !table.getIsSomeRowsSelected() &&
                          !table.getIsAllRowsSelected()
                        }
                        //only export selected rows
                        onClick={() =>
                          downloadPDF(
                            table.getSelectedRowModel().rows,
                            "selectedrow"
                          )
                        }
                        startIcon={<FileDownloadIcon />}
                        variant="contained"
                      >
                        Export Selected Rows in Pdf
                      </Button>
                      {/* <Button
                        size="small"
                        onClick={() =>
                          setPagination({ ...pagination, pageSize: 0 })
                        }
                        variant="contained"
                      >
                        Get All Data
                      </Button> */}
                    </Box>
                  )}
                />

                {/* <AgGridReact
                    rowData={responseData}
                    columnDefs={columnDefs}
                    defaultColDef={defaultColDef}
                    autoGroupColumnDef={autoGroupColumnDef}
                    onGridReady={onGridReady}
                    rowGroupPanelShow={"always"}
                  ></AgGridReact> */}
                {/* </div> */}
              </div>

              {/* <div className="row">
                <div className="col-md-12 text-center">
                  <h6>
                    {currentDate.toLocaleString()} &nbsp;GMT Time: {hours}:
                    {minutes}
                  </h6>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SalesbyCustomerDetail;
